import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";

const Footer = () => {
  const links = [
    { name: "Home", link: "/" },
    { name: "Committee", link: "/committee" },
    { name: "Scientific Program", link: "/event/e-miss-cvj-2026/scientific-program" },
  ];

  return (
    <footer className="neuro-footer">
      <div className="footer-content">
        {/* LOGO SECTION */}
        <div className="logo-container">
          <div className="logo-wrapper">
            <img src="/neurosurgery.png" alt="SGPGI Logo" />
            <div className="footer-logo-text-group">
              <span className="footer-logo-title">SGPGI</span>
              <span className="footer-logo-subtitle">NEUROSURGERY</span>
            </div>
          </div>

          {/* <div className="socials-icon">
            <a href="#" target="_blank" rel="noopener noreferrer">
              <FacebookIcon fontSize="large" style={{ color: "white" }} />
            </a>

            <a href="#" target="_blank" rel="noopener noreferrer">
              <InstagramIcon fontSize="large" style={{ color: "white" }} />
            </a>
          </div> */}
        </div>

        {/* IMPORTANT LINKS */}
        <div className="links-container">
          <h3>Important Links</h3>

          <div className="links">
            {links.map((item, index) => (
              <Link key={index} to={item.link}>
                <ArrowForwardIosIcon fontSize="small" />
                {item.name}
              </Link>
            ))}
          </div>
        </div>

        {/* CONTACT */}
        <div className="links-container">
          <h3>Contact Us</h3>

          <div className="footer-contact-prime">For any queries , call us at:</div>

          <div className="footer-contact-prime">
            <b>80053 81156, 95493 38064</b>
          </div>

          <div className="footer-contact-prime">
            <Link to="/contact" className="footer-contact-button">
              Submit Query
            </Link>
          </div>
        </div>

        {/* MAP */}
        {/* <div className="map-card">
          <iframe
            title="SGPGI Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14251.022520460248!2d80.93565094606592!3d26.752173238903428!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399bfb064de846b9%3A0xc8f7227d966659bc!2sSGPGI%2C%20Lucknow%2C%20Uttar%20Pradesh%20226014!5e0!3m2!1sen!2sin!4v1769681614974!5m2!1sen!2sin"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            loading="lazy"></iframe>
        </div> */}
        <div className="links-container">
          <h3>PCO</h3>

          <img src="/cem.jpg" alt="pco" className="pco-img" style={{ width: "100%", height: "auto" }} />

          <h4 className="footer-contact">CEM Hospitality</h4>
          <div className="footer-contact">
            <b>Pawandeep Anand:</b> 7800902120
          </div>
        </div>
      </div>

      {/* Bottom */}
      <div className="footer-bottom">
        <div className="bottom-container">
          <p>© 2026 SGPGI Neurosurgery. All Rights Reserved.</p>

          <p>
            Powered by{" "}
            <a href="https://www.techbrj.com/" target="_blank" rel="noreferrer" className="footer-dev-link">
              TechBRJ
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
